export function getTotalRemainingTime(date: Date): number {
  var compareDate = new Date();
  const result = date.getTime() - compareDate.getTime();
  return Math.floor(result / 1000);
}

export function getTimeRemaining(total: number): { minutes: number; seconds: number } {
  if (total < 0) return { minutes: 0, seconds: 0 };
  const seconds = Math.floor(total % 60);
  const minutes = Math.floor((total / 60) % 60);
  return {
    minutes,
    seconds,
  };
}
